module.exports = __webpack_public_path__ + "static/media/hero-background.180ff06d.jpg";